import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Chip } from '../finance/FinHappn';

const fdate = (d) => (d ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) : '');

// Logique 360 : les avis Google qui citent cette personne, et leur effet sur la prime du mois (+2 pt / avis positif, −3 / négatif)
export const AvisClientsBloc = ({ avis }) => {
  const { tenantSlug } = useParams();
  if (!avis) return null;
  const n = (avis.pos || 0) + (avis.neg || 0);
  const bonus = avis.bonus_prime || 0;
  return (
    <section className="rounded-2xl border p-4 space-y-3 no-poste-print" data-testid="employee-fiche-avis">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <p className="hp-kicker">Avis clients · {avis.jours || 90} jours</p>
          <h4 className="leading-tight" data-testid="employee-fiche-avis-titre">{n ? `Cité·e dans ${n} avis Google` : 'Pas encore cité·e dans un avis'}</h4>
        </div>
        {n > 0 && <Chip tone={bonus > 0 ? 'good' : bonus < 0 ? 'bad' : 'mid'} testId="employee-fiche-avis-bonus">{bonus > 0 ? `+${bonus}` : bonus} pt sur la prime du mois</Chip>}
      </div>
      {n === 0 ? null : (
        <>
          <div className="flex flex-wrap gap-1.5">
            <Chip tone="good">{avis.pos} positif{avis.pos > 1 ? 's' : ''}</Chip>
            {avis.neg > 0 && <Chip tone="bad">{avis.neg} négatif{avis.neg > 1 ? 's' : ''}</Chip>}
          </div>
          <ul className="space-y-1.5">
            {avis.avis.map((a) => <li key={a.review_id} className="text-[12.5px] leading-snug text-[var(--encre)] bg-[var(--remplissage)] rounded-xl px-3 py-2" data-testid={`employee-fiche-avis-${a.review_id}`}>
              <b className={a.sentiment === 'negatif' ? 'text-[var(--p-c43c12)]' : 'text-[var(--p-1f5a30)]'}>{a.rating} ★ · {a.author_name} · {fdate(a.create_time)}</b> « {a.text} »
            </li>)}
          </ul>
          <Link to={`/${tenantSlug}/relation-client?onglet=analyse`} className="text-[12px] font-bold underline underline-offset-2 text-[var(--texte)]" data-testid="employee-fiche-avis-lien">Voir l'analyse des avis</Link>
        </>
      )}
    </section>
  );
};

export default AvisClientsBloc;
